import { Grid } from "@material-ui/core";
import { useSelector } from "react-redux";
import "./style.scss";
import { useEffect, useRef } from "react";

export const ModalFullScreen = ({ children, container = true }) => {
	const modalRef = useRef(null);
	const systemTheme = useSelector((state) => state.theme.systemTheme);

	useEffect(() => {
		const modalCurrent = modalRef.current;

		const handleMouseMove = (event) => {
			event.stopPropagation(); // Impede a propagação do evento para os elementos abaixo
		};

		if (modalCurrent) {
			modalCurrent.addEventListener("mousemove", handleMouseMove);
		}

		return () => {
			if (modalCurrent) {
				modalCurrent.removeEventListener("mousemove", handleMouseMove);
			}
		};
	}, [modalRef]);

	return (
		<Grid
			ref={modalRef}
			container
			className={`${!container ? "grid-modalFullScreen-no-container" : `grid-modalFullScreen grid-modalFullScreen-${systemTheme}`}`}
		>
			{children}
		</Grid>
	);
};
